import React from 'react';
import { AlertTriangle, Database, RefreshCw, Unplug } from 'lucide-react';
import { Button } from '../Button';
import { Badge } from '../Badge';
import { supabaseConfig } from '../../data/supabaseConfig';
import type { TrafficDataState } from '../../hooks/useTrafficData';
interface DataSourceBarProps {
  status: TrafficDataState['status'];
  error: string | null;
  lastUpdated: Date | null;
  onRefresh: () => void;
}
export function DataSourceBar({
  status,
  error,
  lastUpdated,
  onRefresh
}: DataSourceBarProps) {
  const isConnected = status !== 'not-configured';
  return <div className="flex flex-col gap-3 rounded-xl border border-border bg-card p-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:p-4" data-id="element-22" data-mp="386ko5cq8gmyk">
      <div className="flex items-start gap-2.5" data-id="element-23" data-mp="3447kctv1qz4f">
        {isConnected ? <Database className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" aria-hidden="true" data-id="element-24" data-mp="1wrnwdv2nzjni" /> : <Unplug className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" aria-hidden="true" data-id="element-25" data-mp="1sord025avjii" />}
        <div className="text-xs leading-relaxed text-muted-foreground" data-id="element-26" data-mp="4jhl0s5pu53c">
          <div className="flex flex-wrap items-center gap-2" data-id="element-27" data-mp="9hstaygd47jg">
            <span className="font-medium text-foreground" data-id="element-28" data-mp="9ewznmbjs50t">
              {isConnected ? `Supabase · ${supabaseConfig.monitoredHost}` : 'Not connected'}
            </span>
            {status === 'loading' && <Badge variant="secondary" data-id="element-29" data-mp="3vqc0hv163c3y">Loading…</Badge>}
            {status === 'error' && <Badge variant="destructive" data-id="element-30" data-mp="3hvrr85mwa2zl">Query failed</Badge>}
          </div>
          <p className="mt-1 font-mono" data-id="element-31" data-mp="3moukecnrfaf9">
            {isConnected ? lastUpdated ? `Last ${supabaseConfig.lookbackMinutes / 60}h · updated ${lastUpdated.toLocaleTimeString()}` : 'Waiting for the first response…' : 'No data source configured — this dashboard shows nothing until one is.'}
          </p>
        </div>
      </div>

      <div className="flex shrink-0 items-center gap-2" data-id="element-32" data-mp="33xl2pg3u5fcl">
        <Button variant="outline" size="sm" onClick={onRefresh} disabled={!isConnected || status === 'loading'} data-id="element-33" data-mp="33z4g8yy3xcao">
          <RefreshCw className={'h-3.5 w-3.5 ' + (status === 'loading' ? 'animate-spin' : '')} aria-hidden="true" data-id="element-34" data-mp="14pl5irp5fqt7" />
          Refresh
        </Button>
      </div>

      {error && <p role="alert" className="flex items-start gap-2 text-xs text-destructive sm:basis-full" data-id="element-35" data-mp="vrj4wd9bv06g">
          <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-36" data-mp="1sf5wnxvghudk" />
          {error}
        </p>}
    </div>;
}